import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import React, { Suspense, useContext, useEffect, useState } from 'react';

import AssetListToConvert from 'pages/PosPhonesShop/AssetListToConvert';
import { AuthContext } from 'components/Auth/Auth';
import AutoPayNetting from 'pages/Payment/AutoPayNetting';
import ConActivityTab from 'pages/ProposalV3/Components/ConActivityTab';
import ConfigTabs from 'pages/Configuration/ConfigurationSFS/ConfigTabs';
import ContractDetail from 'pages/ProposalV3/Components/ContractDetail';
import ContractSubTab from 'pages/ProposalV3/Components/ContractSubTab';
import CreateSInvoiceFileService from 'pages/SupplierInvoice/CreateSInvoiceFileService';
import DealerContracts from 'pages/PosPhonesShop/DealerContracts';
import DealerPayment from 'pages/PosPhonesShop/DealerPayment';
import DemandSubTab from 'pages/ProposalV3/Components/DemandSubTab';
import EntityFollowup from 'pages/workflow/EntityFollowUp/EntityFollowUpList';
import ExtendLongTermRental from 'pages/ProposalV3/ExtendLongTermRental';
import FinContractEndOfTermReq from 'pages/ProposalV3/FinContractEndOfTermReq';
import GlobalVision from 'pages/GlobalVisionSFS';
import MyRequests from 'pages/PosPhonesShop/MyRequests';
import NewCarFin from 'pages/PosPhonesShop/NewCarFin';
import Notauthorized from 'pages/404/notauthorized';
import PFileDetail from 'pages/Payment/PFileDetail';
import PFileIMPORT from 'pages/Payment/PFileIMPORT';
import PFileINExtract from 'pages/Payment/PFileINExtract';
import PFileOUTExtract from 'pages/Payment/PFileOUTExtract';
import PaiementSFS from 'pages/ProposalV3/Components/PaymentSFS';
import ParRateDetails from 'pages/Configuration/ConfigurationSFS/ParRate/ParRateDetail';
import ParRateFormulasDetails from 'pages/Configuration/ConfigurationSFS/ParRateFormulas/ParRateFormulasDetails';
import PayListRepresentement from 'pages/Payment/PayRepresentment';
import PaymentSFS from 'pages/ProposalV3/Components/PaymentSFS';
import ProcTaskConseqList from 'pages/workflow/Kafka/ProcTaskConseqList';
import ProductCreation from 'pages/ProductSFS/ProductCreation';
import ProductFamilyDetails from 'pages/Configuration/ConfigurationSFS/ParProduct/ProductFamilyDetail';
import ProductsList from 'pages/ProductSFS/ProductsList';
import RecapProduct from 'pages/ProductSFS/RecapProductSFS';
import ReservationSubTab from 'pages/ProposalV3/Components/ReservationSubTab';
import RunCollection from 'pages/Collection/RunCollection';
import SIFileDetail from 'pages/SupplierInvoice/SIFileDetail';
import ScheduleTopicNotInvoicedList from 'pages/workflow/Kafka/ScheduleTopicNotInvoicedList';
import ScoringDetailV2 from 'pages/Scoring/ScoringDetail/ScoringDetailV2';
import ServicesFollowup from 'pages/Services/ServicesFollowup';
import SimpleQuickSimulation from 'pages/PosPhonesShop/SimpleQuickSimul';
import { Spin } from 'antd';
import StatisticsProdList from 'pages/Statistic/StatisticProductionList';
import SuperSetDocker from 'pages/superset/SuperSetDocker';
import TasksList from 'pages/Tasks/TasksList';
import ThirdPartyCreation from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyCreation/ThirdPartyCreation';
import ThirdPartyDetailsSFS from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyDetailSFS/ThirdPartyDetailsSFS';
import ThirdPartyList from 'components/theme_components/ThirdParty/ThirdPartyList';
import TpList from 'pages/ThirdParty/TpList';
import UsedCarFin from 'pages/PosPhonesShop/UsedCarFin';
import form from 'antd/es/form';
import { useTranslation } from 'react-i18next';

//import PropList from 'pages/Proposal/PropList';


















































interface PrivateRouteProps {
  // Define any props you need here
}

export const PrivateRoute = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    setToken(localStorage.getItem('token'));
  }, []);

  useEffect(() => {
  }, [token]);

  if (!token) {
    localStorage.setItem('token', '');
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

const PurchaseOrderList = React.lazy(
  () => import('pages/Purchase/PurchaseOrderList')
);
const TaskGolablEventModal = React.lazy(
  () => import('pages/workflow/TaskGolablEventModal')
);

const MyCatalog = React.lazy(() => import('pages/PosPhonesShop/myCatalog'));

const SiSasList = React.lazy(() => import('pages/SupplierInvoice/SiSasList'));
const SIfilesList = React.lazy(
  () => import('pages/SupplierInvoice/SIFileList')
);

const ThirdPartyDetail = React.lazy(
  () => import('pages/ThirdParty/ThirdPartyDetail')
);
const CollectionDetail = React.lazy(
  () => import('pages/Collection/CollectionDetail/CollectionDetail')
);
const CollectionList = React.lazy(
  () => import('pages/Collection/CollectionList')
);
const GuarantDetail = React.lazy(
  () => import('pages/guaranty/guarantyDetails')
);
const SuperSet = React.lazy(() => import('pages/superset/SuperSet'));
const Guaranty = React.lazy(() => import('pages/guaranty/guaranty'));
const Landing = React.lazy(() => import('pages/Landing/Landing'));

const PrintingList = React.lazy(
  () => import('pages/Print/PrintingList/PrintingList')
);
const StatisticJobService = React.lazy(
  () => import('pages/Statistic/StatisticJob')
);
const SIList = React.lazy(() => import('pages/SupplierInvoice/SlList'));

const SIDetail = React.lazy(
  () => import('pages/SupplierInvoice/SIDetail/index')
);

const ScoringList = React.lazy(() => import('pages/Scoring/ScoringList'));
const ScoringGridList = React.lazy(
  () => import('pages/Scoring/ScoringGridList')
);
const ScoringGridDetails = React.lazy(
  () => import('pages/Scoring/ScoringGrid/ScoringGridDetails')
);
const ScoringDetail = React.lazy(
  () => import('pages/Scoring/ScoringDetail/ScoringDetailV2')
);
const PurchaseOrderDetail = React.lazy(
  () => import('pages/Purchase/PurchaseOrderDetail')
);
const PropListV3 = React.lazy(() => import('pages/ProposalV3/PropList'));
const PropDetailV3 = React.lazy(() => import('pages/ProposalV3/PropDetail'));
const Portfolio = React.lazy(() => import('pages/PosPhonesShop/portfolio'));
const BrokerContracts = React.lazy(
  () => import('pages/PosPhonesShop/Contracts')
);
const Catalog = React.lazy(() => import('pages/PosPhonesShop/catalog'));
const MyBrokerProfile = React.lazy(
  () => import('pages/Configuration/ManagementCompany/BrokerDetail/index')
);

const PAYNettingList = React.lazy(
  () => import('pages/Payment/PAYNetting/NettingList')
);
const PAYNet = React.lazy(() => import('pages/Payment/PAYNet'));
const PayList = React.lazy(() => import('pages/Payment/PAYList'));
const Lead = React.lazy(() => import('pages/Lead/Lead'));
const FlowEditor = React.lazy(() => import('pages/FlowEditor/FlowEditor'));
const AccountingConfiguration = React.lazy(() => import('pages/Accounting'));
const AssetDetail = React.lazy(() => import('pages/Asset/AssetDetail'));
const AssetList = React.lazy(() => import('pages/Asset/AssetList'));
const AttributeDetail = React.lazy(
  () => import('pages/Attribute/AttributeDetail')
);
const AttributeList = React.lazy(() => import('pages/Attribute/AttributeList'));
const ChangePassword = React.lazy(
  () => import('pages/ChangePassword/ChangePassword')
);
const CIDetail = React.lazy(() => import('pages/ClientInvoice/CIDetail'));
const CIList = React.lazy(() => import('pages/ClientInvoice/CIList'));
const CIPrintingService = React.lazy(
  () => import('pages/ClientInvoice/CIPrintingService')
);
const ConfigurationRoutes = React.lazy(() => import('pages/Configuration'));
const DocList = React.lazy(() => import('pages/Document/DocList'));
const Pay = React.lazy(() => import('pages/Payment/PAYDetail/index'));
const EvollisInvoicingService = React.lazy(
  () => import('pages/ClientInvoice/EvollisInvoicingService')
);

const GenPaymentINService = React.lazy(
  () => import('pages/Payment/PayINService')
);
const PFileINService = React.lazy(() => import('pages/Payment/PFileINService'));
const PFileList = React.lazy(() => import('pages/Payment/PFileList'));
const GenPaymentOUTService = React.lazy(
  () => import('pages/Payment/PayOUTService/index')
);
const PFileOUTService = React.lazy(
  () => import('pages/Payment/PFileOUTService/index')
);
const InvoicingService = React.lazy(
  () => import('pages/ClientInvoice/InvoicingService')
);
const LateChargeService = React.lazy(
  () => import('pages/ClientInvoice/LateChargeService')
);
const LateChargeInvoicingService = React.lazy(
  () => import('pages/ClientInvoice/LateChargeInvoicingService')
);
const EvollisExecContractOperation = React.lazy(
  () => import('pages/Contract/EvollisExecContractOperation')
);
const FinModification = React.lazy(() => import('pages/FinModification'));

const AppRoutes: React.FC = () => {
  const [usertype] = useState(() => localStorage.getItem('usertype'));
  const [userrole] = useState(() => localStorage.getItem('userrole'));
  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation();
  const context = useContext(AuthContext);
  return (
    <Suspense
      fallback={
        <Spin
          size="large"
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      }
    >
      {usertype === 'INTERNAL' ? (
        <Routes>
          <>
            <Route element={<PrivateRoute />}>
            <Route path="configuration-sfs" element={<ConfigTabs/>}/>

            <Route path="configuration-sfs/:tptype" element={<ConfigTabs/>}/>
            <Route path="/configuration-sfs/rateformula/create" element={<ParRateFormulasDetails  />} />
            <Route path="/configuration-sfs/rateformula/:id" element={<ParRateFormulasDetails  />} />
            <Route path="/configuration-sfs/rate/create" element={<ParRateDetails isCreate/>} />
            <Route path="/configuration-sfs/rate/:id" element={<ParRateDetails  />} />
            <Route path="/configuration-sfs/productsfamily/create" element={<ProductFamilyDetails  />} />
            <Route path="/configuration-sfs/productsfamily/:id" element={<ProductFamilyDetails  />} />



            <Route path="globalvision" element={<GlobalVision/>}/>


              <Route
                path="/third-party/create"
                element={<ThirdPartyDetail />}
              />
              <Route
                path="/third-party/:id/:phase"
                element={<ThirdPartyDetail />}
              />
              <Route path="/third-party" element={<TpList />} />

              <Route
                path="/thirdparty-sfs/:id/:tptype"
                element={<ThirdPartyDetailsSFS />}
              />
              <Route
                path="/thirdparty-sfs/:id/:tptype/update"
                element={<ThirdPartyCreation isUpdate />}
              />
              <Route
                path="/thirdparty-sfs/:id/:tptype/grouping"
                element={<ThirdPartyCreation isGrouping />}
              />

              <Route
                path="/thirdparty-sfs/create"
                element={<ThirdPartyCreation />}
              />
              <Route path="/proposal/create" element={<PropDetailV3 />} />
              <Route path="/proposal/:id" element={<PropDetailV3 />} />
              <Route path="/proposal" element={<PropListV3 />} />
              {/* contract routing */}
              <Route path='/activity-sfs' element={<ConActivityTab />} />
              <Route path="/activity-sfs/:id" element={<ContractDetail />} />

              <Route path="/asset/create/:phase" element={<AssetDetail />} />
              <Route path="/asset/:id/:phase" element={<AssetDetail />} />
              <Route path="/asset" element={<AssetList />} />

              <Route path="/supplier-invoice/:id" element={<SIDetail />} />
              <Route path="/supplier-invoice-saas" element={<SiSasList />} />
              <Route path="/supplier-invoice" element={<SIList />} />
              <Route
                path="/supplier-invoice-file/:sfid"
                element={<SIFileDetail />}
              />
              <Route path="/supplier-invoice-file" element={<SIfilesList />} />

              <Route path="/services/followup" element={<ServicesFollowup />} />
              <Route
                path="/supplier-invoicing/run/createSIFile"
                element={<CreateSInvoiceFileService />}
              />
              <Route
                path="/client-invoice/:idOrCreate"
                element={<CIDetail />}
              />
              <Route path="/client-invoice" element={<CIList />} />

              <Route
                path="/client-invoicing/run/evollis"
                element={<EvollisInvoicingService />}
              />
              <Route
                path="/client-invoicing/run/scheduledPayment"
                element={<InvoicingService />}
              />
              <Route
                path="/client-invoicing/run/lateCharge"
                element={<LateChargeService />}
              />
              <Route
                path="/client-invoicing/run/lateChargeInvoicing"
                element={<LateChargeInvoicingService />}
              />

              <Route
                path="/payment/run/genPaymentIN"
                element={<GenPaymentINService />}
              />
              <Route
                path="/payment/run/autoPayNetting"
                element={<AutoPayNetting />}
              />
              <Route
                path="/payment/run/createPaymentFileIN"
                element={<PFileINService />}
              />
              <Route
                path="/payment/run/extractPaymentFileIN"
                element={<PFileINExtract />}
              />
              <Route
                path="/payment/run/extractPaymentFileOUT"
                element={<PFileOUTExtract />}
              />
              <Route
                path="/payment/run/genPaymentOUT"
                element={<GenPaymentOUTService />}
              />
              <Route
                path="/payment/run/createPaymentFileOUT"
                element={<PFileOUTService />}
              />

              <Route
                path="/contract/run/evollis"
                element={<EvollisExecContractOperation />}
              />
              <Route
                path="/contract/finModification"
                element={<FinModification />}
              />
              <Route
                path="/client-invoicing/run/print"
                element={<CIPrintingService />}
              />

              <Route path="/payment/create" element={<Pay />} />
              <Route path="/payment/:id" element={<Pay />} />
              <Route path="/paynetting/create" element={<PAYNet />} />
              <Route path="/paynetting/:payid" element={<PAYNet />} />
              <Route path="/paynetting" element={<PAYNettingList />} />
              <Route path="/paynetting/paynet" element={<PAYNet />} />
              <Route path="/payment" element={<PayList />} />
              <Route
                path="/paymentfile"
                element={<PFileList paydirection="" />}
              />
              <Route path="/pfiledetail/:pfid" element={<PFileDetail />} />
              <Route path="/scoring/create" element={<ScoringDetailV2 />} />
              <Route path="/scoring/:id" element={<ScoringDetailV2 />} />
              <Route path="/scoring" element={<ScoringList />} />

              <Route
                path="/parscoring/grid/create"
                element={<ScoringGridDetails />}
              />
              <Route
                path="/parscoring/grid/:id"
                element={<ScoringGridDetails />}
              />
              <Route
                path="/parscoring/grid/:id/:duplicate"
                element={<ScoringGridDetails />}
              />
              <Route path="/parscoring/grid" element={<ScoringGridList />} />
              <Route
                path="/purchase-order/:idOrCreate"
                element={<PurchaseOrderDetail />}
              />
              <Route path="/purchase-order" element={<PurchaseOrderList />} />
              <Route path="/document" element={<DocList categorie="DOC" />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/catalog/create" element={<Catalog />} />
              <Route path="/catalog/:id" element={<Catalog />} />
              <Route path="/newCarFinancing" element={<NewCarFin />} />
              <Route
                path="/catalog/contract/:id/PROD"
                element={<SimpleQuickSimulation />}
              />
              <Route path="/mycatalog" element={<MyCatalog />} />
              <Route path="/myportfolio" element={<Portfolio />} />
              <Route path="/mycontract" element={<BrokerContracts />} />
              <Route
                path="/dealercontract/:status"
                element={<DealerContracts />}
              />
              <Route path="/dealerpayment" element={<DealerPayment />} />
              <Route path="/partner/myProfile" element={<MyBrokerProfile />} />
              <Route
                path="/parscoring/attribute/create"
                element={<AttributeDetail />}
              />
              <Route
                path="/parscoring/attribute/:idfromUrl/:duplicate"
                element={<AttributeDetail />}
              />
              <Route
                path="/parscoring/attribute/:idfromUrl"
                element={<AttributeDetail />}
              />
              <Route path="/parscoring/attribute" element={<AttributeList />} />
              <Route path="/flow-editor" element={<FlowEditor />} />
              <Route
                path="/statistics/run/production"
                element={<StatisticJobService />}
              />
              <Route
                path="/statistics/production"
                element={<StatisticsProdList />}
              />
              <Route
                path="/accounting/*"
                element={<AccountingConfiguration />}
              />

              {userrole === 'ADMIN' && (
                <Route
                  path="/configuration/*"
                  element={<ConfigurationRoutes />}
                />
              )}

              <Route path="/change-password" element={<ChangePassword />} />
              <Route
                path="/paymentrepresentement"
                element={<PayListRepresentement />}
              />
              <Route path="/pfileimport" element={<PFileIMPORT />} />
              <Route path="/lead/create" element={<Lead />} />
              <Route path="/lead/:id" element={<Lead />} />
              <Route path="/" element={<Landing />} />
              <Route path="/welcome" element={<Landing />} />
              <Route path="/landing" element={<Landing />} />

              <Route path="/guaranty" element={<Guaranty />} />
              <Route path="/guaranty/:idOrCreate" element={<GuarantDetail />} />
              <Route path="/superset/:id" element={<SuperSet />} />
              <Route path="/supersetdocker/:id" element={<SuperSetDocker />} />
              <Route path="/collection" element={<CollectionList />} />
              <Route path="/collection/run" element={<RunCollection />} />
              <Route path="/collection/:id" element={<CollectionDetail />} />
              <Route path="/event/global" element={<TaskGolablEventModal />} />
              <Route path="/tasks" element={<TasksList />} />
              <Route path="/product/productcreation" element={<ProductCreation />} />
              <Route path="/product/recap/:id" element={<RecapProduct />} />
              <Route
                path="/workflow/entityfollowup"
                element={<EntityFollowup />}
              />
              <Route
                path="/workflow/KafkaTopic/ScheduleTopicNotInvoiced"
                element={<ScheduleTopicNotInvoicedList />}
              />
              <Route
                path="/workflow/Kafka/proctaskconseqlist"
                element={<ProcTaskConseqList />}
              />
              <Route path="/printinglist" element={<PrintingList />} />
              <Route
                path="/fin-contract/run/endoftermreq"
                element={<FinContractEndOfTermReq />}
              />
              <Route
                path="/product/productsList"
                element={<ProductsList />} />
              <Route
                path="/fin-contract/run/extendlongtermrental"
                element={<ExtendLongTermRental />}
              />
              <Route path="/payment-sfs" element={<PaymentSFS />} />
            </Route>
            <Route path="*" element={<Navigate to="/pageNotFound" replace />} />
          </>
        </Routes>
      ) : (
        <Routes>
          <>
            <Route element={<PrivateRoute />}>
              {/* {context.menu.find((item: any) =>
                item.pagurl.includes('/third-party')
              ) !== undefined && (
                  <Route
                    path="/third-party/create"
                    element={<ThirdPartyDetailSFS />}
                  />
                )} */}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/third-party')
              ) !== undefined && (
                  <Route path="/third-party" element={<ThirdPartyList />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/proposal')
              ) !== undefined && (
                  <Route path="/proposal/create" element={<PropDetailV3 />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/proposal')
              ) !== undefined && (
                  <Route path="/proposal/:id" element={<PropDetailV3 />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/proposal')
              ) !== undefined && (
                  <Route path="/proposal" element={<PropListV3 />} />
                )}
              <Route
                path="/fin-contract/run/endoftermreq"
                element={<FinContractEndOfTermReq/>}
              />

              {context.menu.find((item: any) =>
                item.pagurl.includes('/asset')
              ) !== undefined && (
                  <Route path="/asset/create/:phase" element={<AssetDetail />} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/asset')
              ) !== undefined && (
                  <Route path="/asset/:id/:phase" element={<AssetDetail />} />
                )}
              {context.menu.find((item: any) => item.pagurl === '/asset') !==
                undefined && <Route path="/asset" element={<AssetList />} />}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/supplier-invoice')
              ) !== undefined && (
                  <Route path="/supplier-invoice/:id" element={<SIDetail />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/supplier-invoice-sas')
              ) !== undefined && (
                  <Route path="/supplier-invoice-saas" element={<SIDetail />} />
                )}
              {context.menu.some(
                (item: any) => item.pagurl === '/supplier-invoice'
              ) !== undefined && (
                  <Route path="/supplier-invoice" element={<SIList />} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoice')
              ) !== undefined && (
                  <Route
                    path="/client-invoice/:idOrCreate"
                    element={<CIDetail />}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoice')
              ) !== undefined && (
                  <Route path="/client-invoice" element={<CIList />} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoicing')
              ) !== undefined && (
                  <Route
                    path="/client-invoicing/run/evollis"
                    element={<EvollisInvoicingService />}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoicing')
              ) !== undefined && (
                  <Route
                    path="/client-invoicing/run/scheduledPayment"
                    element={<InvoicingService />}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoicing')
              ) !== undefined && (
                  <Route
                    path="/client-invoicing/run/lateCharge"
                    element={<LateChargeService />}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoicing')
              ) !== undefined && (
                  <Route
                    path="/client-invoicing/run/lateChargeInvoicing"
                    element={<LateChargeInvoicingService />}
                  />
                )}

              {context.menu.some((item: any) =>
                item.pagurl.includes('/contract')
              ) !== undefined && (
                  <Route
                    path="/contract/run/evollis"
                    element={<EvollisExecContractOperation />}
                  />
                )}
              {context.menu.some((item: any) => item.pagurl === '/contract') !==
                undefined && (
                  <Route
                    path="/contract/finModification"
                    element={<FinModification />}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/services')
              ) !== undefined && (
                  <Route path="/services/followup" element={<ServicesFollowup/>} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/client-invoicing')
              ) !== undefined && (
                  <Route
                    path="/client-invoicing/run/print"
                    element={<CIPrintingService/>}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/payment')
              ) !== undefined && (
                  <Route path={'/payment/create'} element={<Pay/>} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/payment')
              ) !== undefined && <Route path={'/payment/:id'} element={<Pay/>} />}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/paynetting')
              ) !== undefined && (
                  <Route path={'/paynetting/create'} element={<PAYNet />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/paynetting')
              ) !== undefined && (
                  <Route path={'/paynetting/:payid'} element={<PAYNet />} />
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/paynetting'
              ) !== undefined && (
                  <Route path="/paynetting" element={<PAYNettingList />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/paynetting')
              ) !== undefined && (
                  <Route path="/paynetting/paynet" element={<PAYNet />} />
                )}

              {context.menu.find((item: any) => item.pagurl === '/payment') !==
                undefined && <Route path="/payment" element={<PayList />} />}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/scoring')
              ) !== undefined && (
                  <Route path={'/scoring/create'} element={<ScoringDetail />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/scoring')
              ) !== undefined && (
                  <Route path={'/scoring/:id'} element={<ScoringDetail />} />
                )}
              {context.menu.find((item: any) => item.pagurl === '/scoring') !==
                undefined && (
                  <Route path="/scoring" element={<ScoringList />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route
                    path={'/parscoring/grid/create'}
                    element={<ScoringGridDetails />}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route
                    path={'/parscoring/grid/:id'}
                    element={<ScoringGridDetails />}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route
                    path={'/parscoring/grid/:id/:duplicate'}
                    element={<ScoringGridDetails />}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route path="/parscoring/grid" element={<ScoringGridList/>} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/purchase-order')
              ) !== undefined && (
                  <Route
                    path={'/purchase-order/:idOrCreate'}
                    element={<PurchaseOrderDetail/>}
                  />
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/purchase-order'
              ) !== undefined && (
                  <Route path="/purchase-order" element={<PurchaseOrderList/>} />
                )}
              {context.menu.find((item: any) => item.pagurl === '/document') !==
                undefined && (
                  <Route path="/document" element={<DocList categorie="DOC" />} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/catalog')
              ) !== undefined && <Route path={'/catalog'} element={<Catalog/>} />}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/catalog')
              ) !== undefined && (
                  <Route path={'/catalog/create'} element={<Catalog/>} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/catalog')
              ) !== undefined && (
                  <Route path={'/catalog/:id'} element={<Catalog/>} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/newCarFinancing')
              ) !== undefined && (
                  <Route path={'/newCarFinancing'} element={<NewCarFin />} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/conversionFamily')
              ) !== undefined && (
                  <Route
                    path={'/conversionFamily'}
                    element={<AssetListToConvert />}
                  />
                )}

              <Route
                path={'/assetListToConvert'}
                element={<AssetListToConvert />}
              />
              <Route
                path={'assetListToConvert'}
                element={<AssetListToConvert />}
              />

              {context.menu.find((item: any) =>
                item.pagurl.includes('/conversionFamily')
              ) !== undefined && (
                  <Route
                    path={'/conversionFamily'}
                    element={<AssetListToConvert />}
                  />
                )}

              <Route path={'/myRequests'} element={<MyRequests />} />

              <Route path={'/usedCarFinancing'} element={<UsedCarFin />} />

              {context.menu.find((item: any) =>
                item.pagurl.includes('/catalog')
              ) !== undefined && (
                  <Route path={'/mycatalog'} element={<MyCatalog />} />
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/myportfolio'
              ) !== undefined && (
                  <Route path="/myportfolio" element={<Portfolio />} />
                )}
              <Route
                path="/dealercontract/:status"
                element={<DealerContracts />}
              />

              <Route path="/dealerpayment" element={<DealerPayment />} />

              {context.menu.find(
                (item: any) => item.pagurl === '/partner/myProfile'
              ) !== undefined && (
                  <Route
                    path="/partner/myProfile"
                    element={<MyBrokerProfile />}
                  />
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/mycontract'
              ) !== undefined && (
                  <Route path="/mycontract" element={<BrokerContracts />} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route
                    path={'/parscoring/attribute/create'}
                    element={<AttributeDetail />}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route
                    path={'/parscoring/attribute/:idfromUrl/:duplicate'}
                    element={<AttributeDetail />}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route
                    path={'/parscoring/attribute/:idfromUrl'}
                    element={<AttributeDetail />}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <Route path="/parscoring/attribute" element={<AttributeList/>} />
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/flow-editor'
              ) !== undefined && (
                  <Route path="/flow-editor" element={<FlowEditor/>} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/statistics')
              ) !== undefined && (
                  <Route
                    path="/statistics/run/production"
                    element={<StatisticJobService/>}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/statistics')
              ) !== undefined && (
                  <Route
                    path="/statistics/production"
                    element={<StatisticsProdList/>} />
                )}
              {userrole === 'ADMIN' &&
                (context.menu.find((item: any) =>
                  item.pagurl.includes('/configuration')
                ) !== undefined ||
                  context.menu.find((item: any) =>
                    item.pagurl.includes('/mycatalog')
                  ) !== undefined) && (
                  <Route path="/configuration" element={<ConfigurationRoutes/>} />
                )}

              <Route path="/change-password" element={<ChangePassword/>} />

              {context.menu.find((item: any) =>
                item.pagurl.includes('/lead')
              ) !== undefined && (
                  <Route path={'/lead/create'} element={<Lead />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/lead')
              ) !== undefined && (
                  <Route path={'/lead/:id'} element={<Lead />} />
                )}

              <Route path={'/'} element={<Landing />} />

              <Route path={'/welcome'} element={<Landing />} />

              {context.menu.find((item: any) => item.pagurl === '/landing') !==
                undefined && <Route path={'/landing'} element={<Landing />} />}
              {context.menu.find((item: any) => item.pagurl === '/guaranty') !==
                undefined && (
                  <Route path={'/guaranty'} element={<Guaranty />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/guaranty')
              ) !== undefined && (
                  <Route path="/guaranty/:idOrCreate" element={<GuarantDetail/>} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/superset')
              ) !== undefined && (
                  <Route path="/superset/:id" element={<SuperSet/>} />
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/collection'
              ) !== undefined && (
                  <Route path={'/collection'} element={<CollectionList />} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/collection')
              ) !== undefined && (
                  <Route path={'/collection/:id'} element={<CollectionDetail/>} />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/printinglist')
              ) !== undefined && (
                  <Route path="/printinglist" element={<PrintingList/>} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/tasks')
              ) !== undefined && (
                  <Route path={'/tasks'} element={<TasksList />} />
                )}

              <Route
                path={'/workflow/entityfollowup'}
                element={<EntityFollowup />}
              />

              <Route path="/product/productcreation" element={<ProductCreation />} />
              <Route path="/product/recap/:id" element={<RecapProduct />} />

              <Route
                path={'/workflow/KafkaTopic/ScheduleTopicNotInvoiced'}
                element={<ScheduleTopicNotInvoicedList />}
              />

              <Route
                path={'/workflow/Kafka/proctaskconseqlist'}
                element={<ProcTaskConseqList />}
              />

              <Route
                path="*"
                element={<Navigate to="/pageNotFound" replace />}
              />
            </Route>
          </>
        </Routes>
      )}
    </Suspense>
  );
};

export default AppRoutes;
